import { Component, OnInit, inject } from '@angular/core';
import { Background } from '../../shared/components/background/background';
import { Connect } from '../../shared/components/connect/connect';
import { HeroSection } from '../../shared/components/hero-section/hero-section';
import { Router } from '@angular/router';
import { InfoCard } from '../../shared/components/info-card/info-card';
import { Button } from '../../shared/components/button/button';
import { Process } from "./components/process/process";
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-influencer-process',
  imports: [Background, HeroSection, InfoCard, Button, Connect, Process],
  templateUrl: './influencer-process.html',
  styleUrl: './influencer-process.scss'
})
export class InfluencerProcess implements OnInit {

  protected file = 'influencer-process';

  private router = inject(Router);
  private seo = inject(SeoService);

  ngOnInit() {
    this.seo.apply({
      title: 'Influencer Marketing',
      description: 'SEM Nexus manages creator sourcing, briefs, content, and tracking to run influencer campaigns that scale installs and conversions for mobile apps.',
      canonical: '/influencer-process/',
      image: 'https://semnexus.com/images/influencer-process/backgrounds/influencer-process.avif',
      imageAlt: 'Influencer marketing services by SEM Nexus',
      type: 'website',
    });
    this.seo.setBreadcrumbs([
      { name: 'Home', url: '/' },
      { name: 'Influencer Marketing' },
    ]);
    this.seo.setJsonLd('service', {
      '@context': 'https://schema.org',
      '@type': 'Service',
      '@id': 'https://semnexus.com/influencer-process/#service',
      name: 'Influencer Marketing',
      serviceType: 'Creator sourcing, campaign management, and performance tracking',
      description: 'Influencer sourcing, campaign management, and performance tracking for mobile app growth.',
      provider: { '@id': 'https://semnexus.com/#organization' },
      areaServed: { '@type': 'Country', name: 'United States' },
      url: 'https://semnexus.com/influencer-process/',
    });
  }

  goToCaseStudies() {
    this.router.navigate(['marketing-case-studies']);
  }
}
